import { render, staticRenderFns } from "./WorkspaceLeadSnpSummary.vue?vue&type=template&id=5c15f142&scoped=true"
import script from "./WorkspaceLeadSnpSummary.vue?vue&type=script&lang=js"
export * from "./WorkspaceLeadSnpSummary.vue?vue&type=script&lang=js"
import style0 from "./WorkspaceLeadSnpSummary.vue?vue&type=style&index=0&id=5c15f142&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c15f142",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/CFDE Knowledge - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c15f142')) {
      api.createRecord('5c15f142', component.options)
    } else {
      api.reload('5c15f142', component.options)
    }
    module.hot.accept("./WorkspaceLeadSnpSummary.vue?vue&type=template&id=5c15f142&scoped=true", function () {
      api.rerender('5c15f142', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/revealKgWorkspace/WorkspaceLeadSnpSummary.vue"
export default component.exports